import { ShieldCheck } from "lucide-react";

/** Discreet copyright/anti-piracy mention shown on music + live pages. */
export default function CopyrightNotice({ className = "" }) {
  return (
    <p
      className={`text-[10px] text-zinc-500 leading-relaxed flex items-start gap-1.5 ${className}`}
      data-testid="copyright-notice"
    >
      <ShieldCheck className="w-3 h-3 text-zinc-600 shrink-0 mt-0.5" />
      <span>
        Contenu prot&eacute;g&eacute; par les droits d&apos;auteur. Toute reproduction ou
        enregistrement non autoris&eacute; est strictement interdit et passible de
        poursuites judiciaires.
      </span>
    </p>
  );
}
